export default "__VITE_ASSET__D3UXcW08__"